import {useVisualizerSession} from "../../visualizer/VscVisualizerSession";
import React, {useState} from "react";
import IVscCommunityMapInfo from "../../../visualizers/IVscCommunityMapInfo";
import SiteSpecificInfo from "../siteSpecific/SiteSpecificInfo";
import PlanAdminInfo from "./PlanAdminInfo";
import {IModel} from "../../../kova/slsordClient";
import {IConfiguratorProxy} from "@bimaire/optionslib";
import {IModelConfig} from "../../../data/IViewpoint";

export interface IPlanAdminProps {
    modelConfig: IModelConfig,
    activeCamera: string,
    model: IModel,
    configurator: IConfiguratorProxy
}

const PlanAdmin: React.FC<IPlanAdminProps> = (props) => {


    const {modelConfig, configurator, model} = props;

    const screenprops = [
        ["Active Camera", props.activeCamera ?? "none"],
        ["Lot ID", modelConfig.lotId],
        ["Plan ID", model.id],
    ];
    const visualizerSession = useVisualizerSession();

    const [mapInfo, setMapInfo] = useState<IVscCommunityMapInfo | null>(null);
    const loadMapInfo = async () => {
        const mapInfoResponse = await visualizerSession.requestMapInfo();

        setMapInfo(mapInfoResponse);
    }

    return <main>
        <h1>Vsc Admin / SiteSpecific</h1>

        <table>
            <tr>
                <th>Property</th>
                <th>Value</th>
            </tr>
            {screenprops.map((prop) => <tr>
                <td>{prop[0]}</td>
                <td>{prop[1]}</td>
            </tr>)
            }
        </table>

        <button onClick={() => loadMapInfo()}>Load map info</button>
        {mapInfo && <PlanAdminInfo mapInfo={mapInfo} modelConfig={modelConfig} model={model} configurator={configurator}/>}
    </main>
}
export default PlanAdmin;